/*
    创建者：shuxiaokai
    创建时间：2020-04-30 20:42
    模块名称：卡片widget
    备注：xxxx
*/
<template>
    <s-drag-move :id="id">
        <div 
                class="s-card-widget"
                :style="{ left: left + 'px', top: top + 'px', width: width + 'px', height: height + 'px' }"
        >
        </div>        
    </s-drag-move>

</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            offsetLeft: 0, //鼠标按下位置
            offsetTop: 0, //鼠标按下位置
        };
    },
    computed: {
        currentWidget() {
            return this.$store.state.widget.widgetList.find(val => val.id === this.id);
        },
        width() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.id);
            return currentWidget.boundingClientRect.width;
        },
        height() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.id);
            return currentWidget.boundingClientRect.height;
        },
        left() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.id);
            return currentWidget.boundingClientRect.clientLeft;
        },
        top() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.id);
            return currentWidget.boundingClientRect.clientTop;
        },
    },
    mounted() {
       
    },
    methods: {
        //=====================================获取远程数据==================================//
        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
       
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.s-card-widget {
    background: teal;
    position: absolute;
    user-select: none;
    z-index: 2;
}
</style>
